import script from "./DevicesAndUsers.vue?vue&type=script&setup=true&lang=ts"
export * from "./DevicesAndUsers.vue?vue&type=script&setup=true&lang=ts"

import "./DevicesAndUsers.vue?vue&type=style&index=0&id=37eae54a&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37eae54a"]])

export default __exports__